export enum StartupHelpTutorialType {
  Home = "Home",
  IngestNewRequest = "IngestNewRequest",
  Markers = "Markers",
  Ingest = "Ingest",
}
